// eslint-disable-next-line
import { h, Component } from 'preact';
import smoothscroll from 'smoothscroll-polyfill';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'preact-css-transition-group';
import classNames from 'classnames';

import styles from './index.scss';

// kick off the polyfill!
smoothscroll.polyfill();

const SCREENS_NUM_TRIGGER_THRESHOLD = 4;

class BackToTop extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
        };

        window.addEventListener('scroll', () => {
            const { innerHeight, pageYOffset } = window;
            const scrolledFullScreens = Math.floor(pageYOffset / innerHeight) + 1;

            if (scrolledFullScreens >= SCREENS_NUM_TRIGGER_THRESHOLD) {
                this.setState({ show: true });
            } else if (pageYOffset === 0) {
                this.setState({ show: false });
            }
        });
    }
    handleClick() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
    render() {
        const buttonClasses = classNames({
            [styles.backToTop]: true,
            [styles.shift]: this.props.isBannerShow,
        });
        return (
            <CSSTransitionGroup component="div" transitionName="apc-btt">
                {this.state.show ? (
                    <div onClick={this.handleClick} className={buttonClasses} {...this.props} />
                ) : null}
            </CSSTransitionGroup>
        );
    }
}

BackToTop.propTypes = {
    isBannerShow: PropTypes.bool,
};
export default BackToTop;
